import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-28cada00"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "settings" }
const _hoisted_2 = { class: "settings-wrap" }
const _hoisted_3 = { class: "wrap" }
const _hoisted_4 = { class: "title-wrap" }
const _hoisted_5 = { class: "volume" }
const _hoisted_6 = { class: "volume" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Typography = _resolveComponent("Typography")!
  const _component_Select = _resolveComponent("Select")!
  const _component_Range = _resolveComponent("Range")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_Button, {
            class: "get-back",
            iconOnly: "",
            mode: "flat",
            icon: {name: 'ic20-chevron-left', color: '--sui-gray-900'},
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openCallState(_ctx.activeCallId || _ctx.selectCallId)))
          }),
          _createVNode(_component_Typography, { class: "title" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t('title')), 1)
            ]),
            _: 1
          })
        ]),
        (_ctx.settings.videoDevices?.length)
          ? (_openBlock(), _createBlock(_component_Select, {
              key: 0,
              class: "video-select",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = (device) => _ctx.chooseVideoDevice(device)),
              modelValue: _ctx.settings.activeVideoDevice,
              disabled: _ctx.isCallPaused,
              size: "s",
              label: _ctx.t('videoInput'),
              options: _ctx.settings.videoDevices.map((device) => ({label: device.name || 'default', value: device.id || device.group}))
            }, null, 8, ["modelValue", "disabled", "label", "options"]))
          : _createCommentVNode("", true),
        _createVNode(_component_Select, {
          class: "audio-select",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = (device) => _ctx.chooseAudioDevice(device)),
          modelValue: _ctx.settings.activeAudioDevice,
          disabled: _ctx.isCallPaused,
          size: "s",
          label: _ctx.t('audioInput'),
          options: _ctx.settings.audioDevices.map((device) => ({label: device.name || 'default', value: device.id || device.group}))
        }, null, 8, ["modelValue", "disabled", "label", "options"]),
        _createVNode(_component_Typography, { class: "title-audio" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.t('ringtone')), 1)
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_Button, {
            mode: "flat",
            iconOnly: "",
            icon: {name: 'ic20-volume-off', color: '--sui-gray-700'},
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.changeVolume({ ringtoneVolume: 0 })))
          }),
          _createVNode(_component_Range, {
            class: "volume-range",
            id: "ringtone-volume",
            volumeValue: _ctx.settings.ringtoneVolume,
            onInput: _cache[4] || (_cache[4] = (volumeValue) => _ctx.changeVolume({ ringtoneVolume: Number(volumeValue) }))
          }, null, 8, ["volumeValue"]),
          _createVNode(_component_Button, {
            mode: "flat",
            iconOnly: "",
            icon: {name: 'ic20-volume-max', color: '--sui-gray-700'},
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.changeVolume({ ringtoneVolume: 1 })))
          })
        ]),
        _createVNode(_component_Typography, { class: "title-audio" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.t('call')), 1)
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_Button, {
            mode: "flat",
            iconOnly: "",
            icon: {name: 'ic20-volume-off', color: '--sui-gray-700'},
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.changeVolume({ callVolume: 0 })))
          }),
          _createVNode(_component_Range, {
            class: "volume-range",
            id: "call-volume",
            volumeValue: _ctx.settings.callVolume,
            onInput: _cache[7] || (_cache[7] = (volumeValue) => _ctx.changeVolume({ callVolume: volumeValue }))
          }, null, 8, ["volumeValue"]),
          _createVNode(_component_Button, {
            mode: "flat",
            iconOnly: "",
            icon: {name: 'ic20-volume-max', color: '--sui-gray-700'},
            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.changeVolume({ callVolume: 1 })))
          })
        ])
      ]),
      _createVNode(_component_Button, {
        class: "button-apply",
        onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.openCallState(_ctx.activeCallId || _ctx.selectCallId)))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.t('button')), 1)
        ]),
        _: 1
      })
    ])
  ]))
}